import React from 'react'
// KAS-339 SELECTED_CUSTOMER_TYPE action don't use any more, use WatchField instead
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Snackbar from '@material-ui/core/Snackbar'
import { MySnackbarContentWrapper } from '../../utils/snackbar.utils'
import Button from '@material-ui/core/Button'
import { scrollToTop } from '../../utils/scrollTo'
import UserSelectorContainer from '../../containers/layout/userSelector.container'
import { Translation } from 'react-i18next'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import CustomerForm from './customerForm.component'
import SortableTable from '../../utils/sortableTable'
import CustomerRowComponent from './customerRow.component'

class CustomerComponent extends React.Component {
  componentDidMount() {
    if (this.props.userType == 2) {
      this.props.getAdminUsersList()
    }
    this.props.getCountryList()
    this.props.getCustomersStart()
    this.props.getEinvoiceOperator()
    this.props.getUserCompanyUpdateInfo()
    scrollToTop()
  }

  render() {
    return <Customer {...this.props} />
  }
}

const styles = (theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',

    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    }
  },
  dialog: {
    backgroundColor: theme.palette.common.dialogBackground
  },
  tablecell: {
    fontWeight: 'bold',
    fontSize: '13px',
    color: 'black'
  },
  button: {
    marginLeft: 10
  },
  button1: {
    backgroundColor: '#FFF0F5',
    '&:hover': {
      backgroundColor: '#F67131'
    }
  },
  dialogButton: {
    margin: theme.spacing(1)
  },
  select: {
    marginTop: theme.spacing(4),
    border: '1px solid gray',
    fontSize: '14px'
  },
  textField: {
    marginTop: theme.spacing(4),
    border: '1px solid gray',
    fontSize: '14px'
  },
  resize: {
    fontSize: '14px'
  },
  label: {
    [theme.breakpoints.down('370')]: {
      marginTop: 45
    }
  },
  checkbox: {
    marginTop: theme.spacing(5),
    fontSize: '15px',
    fontWeight: 500,
    color: '#808080'
  },
  dropDownListsTextField: {
    position: 'relative'
  },

  dropDownLists: {
    position: 'absolute',
    width: '100%',
    zIndex: 3,
    background: '#f9f9f9'
  }
})

const Customer = ({
  eInvoiceOperators,
  isEdit,
  addNewCustomer,
  saveCustomerUpdate,
  cancelCustomerUpdate,
  showSnackbar,
  showFailSnackbar,
  closeCustomerSnackBar,
  classes,
  userType,
  countryList,
  removeCustomer,
  cancelDeleteCustomer,
  isToDelete,
  isToDeleteCustomerId,
  // searchCompanyDetails,
  // companyLists,
  // loadSelectedCompany,
  // apiSuccess,
  // closeCompanyLists,
  // companySelected,
  openCustomerFormDialog,
  closeCustomerFormDialog,
  openCustomerForm,
  customers
}) => {
  return (
    <Translation>
      {(t) => {
        return (
          <div className="container">
            <div className="row">
              {userType == 2 && <UserSelectorContainer></UserSelectorContainer>}
            </div>
            <div className="row">
              <div className="dashboard-content-header">
                <h1>{t('asiakkaat.h1')}</h1>
              </div>
            </div>
            <div className="row">
              <div className="pull-right" style={{ padding: '0px 15px 15px' }}>
                <Button
                  variant="contained"
                  className={classes.button}
                  onClick={openCustomerFormDialog}
                >
                  {t('asiakkaat.muok2')}
                </Button>
              </div>
              <div className="dashboard-content-header">
                <div className="col-xs-12 col-sm-12 col-lg-12">
                  <div className="panel panel-default">
                    <div className="panel-heading">
                      <h3 className="panel-title">{t('asiakkaat.h3')}</h3>
                    </div>
                    <div className="panel-body pd-0">
                      <SortableTable
                        data={customers}
                        createRowComponent={createCustomerRow}
                        headerCells={customerCells}
                        enableFilters={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Dialog
              open={openCustomerForm}
              fullWidth
              maxWidth="lg"
              onClose={closeCustomerFormDialog}
            >
              <DialogContent>
                <CustomerForm
                  isEdit={isEdit}
                  saveCustomerUpdate={saveCustomerUpdate}
                  addNewCustomer={addNewCustomer}
                  countryList={countryList}
                  eInvoiceOperators={eInvoiceOperators}
                  cancelCustomerUpdate={cancelCustomerUpdate}
                  userType={userType}
                  closeCustomerFormDialog={closeCustomerFormDialog}
                />
              </DialogContent>
            </Dialog>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={showSnackbar}
              autoHideDuration={4000}
              onClose={() => {
                closeCustomerSnackBar()
              }}
            >
              <MySnackbarContentWrapper
                onClose={() => {
                  closeCustomerSnackBar()
                }}
                variant="success"
                message={t('asiakkaat.msg')}
              />
            </Snackbar>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={showFailSnackbar}
              autoHideDuration={4000}
              onClose={() => {
                closeCustomerSnackBar()
              }}
            >
              <MySnackbarContentWrapper
                onClose={() => {
                  closeCustomerSnackBar()
                }}
                variant="error"
                message={t('asiakkaat.msg2')}
              />
            </Snackbar>
            <Dialog
              open={isToDelete}
              onClose={cancelDeleteCustomer}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              BackdropProps={{
                classes: {
                  root: classes.dialog
                }
              }}
            >
              <DialogTitle id="alert-dialog-title">
                <span style={{ fontSize: '20px' }}>
                  {t('asiakkaat.dialogTitle')}
                </span>
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <span style={{ fontSize: '14px' }}>
                    {t('asiakkaat.dialogContent')}
                  </span>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <div className="pull-right">
                  <Button
                    variant="outlined"
                    className={classes.dialogButton}
                    onClick={cancelDeleteCustomer}
                  >
                    {t('asiakkaat.dialogCancel')}
                  </Button>
                  <Button
                    variant="contained"
                    className={classes.dialogButton}
                    onClick={() => {
                      removeCustomer(isToDeleteCustomerId)
                    }}
                  >
                    {t('asiakkaat.dialogDelete')}
                  </Button>
                </div>
              </DialogActions>
            </Dialog>
          </div>
        )
      }}
    </Translation>
  )
}

const customerCells = [
  {
    id: 'company_name',
    label: 'asiakkaat.asiak',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    },
    filter: {
      type: 'string'
    }
  },
  {
    id: 'person_to_contact',
    label: 'asiakkaat.yht',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    },
    filter: {
      type: 'string'
    },
    className: 'hide-mobile'
  },
  {
    id: 'person_to_contact_email',
    label: 'asiakkaat.sähk',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    },
    filter: {
      type: 'string'
    },
    className: 'hide-mobile'
  },
  {
    id: 'full_address',
    label: 'asiakkaat.osoi',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    },
    filter: {
      type: 'string'
    },
    className: 'hide-mobile'
  },
  {
    id: 'actions',
    label: 'asiakkaat.toimi',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    }
  }
]

const createCustomerRow = (el, index) => {
  return (
    <CustomerRowComponent
      index={index}
      key={el.customer_id}
      companyName={el.company_name}
      contactPersonName={el.person_to_contact}
      contactPersonEmail={el.person_to_contact_email}
      address={el.delivery_address}
      zipCode={el.zip_code}
      city={el.city}
      customer_id={el.customer_id}
      functions=""
    />
  )
}

CustomerComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(CustomerComponent)
